import axios from "../../../../api/axios";

import { SendTextMessagePayload } from "../types/chat";

export async function sendChatMessage(payload: SendTextMessagePayload) {
  const response = await axios.post("/api/chats", payload);
  return response.data;
}

export async function sendServiceChatMessage(payload: SendTextMessagePayload) {
  const response = await axios.post("/api/services/chats", payload);
  return response.data;
}

export async function updateLastSeenChat(threadId: string) {
  const response = await axios.patch("/last-seen", { threadId });
  return response.data;
}

export async function updateLastSeenServiceChat(threadId: string) {
  const response = await axios.patch("/api/services/chats/last-seen", { threadId });
  return response.data;
}
